import { i18n } from 'vue-lang-router';

export default {
  methods: {
    formatUserRole: (role) => {
      let userRole = '';
      switch (role) {
        case 'wholesaler':
          userRole = i18n.t('auth.wholesaler');
          break;
        case 'mechanic':
          userRole = i18n.t('auth.mechanic');
          break;
        case 'car_owner':
          userRole = i18n.t('auth.carOwner');
          break;
        default:
          userRole = role;
          break;
      }
      return userRole;
    },
  },
};
